import { render, staticRenderFns } from "./RelatorioDapsTomados.vue?vue&type=template&id=2eab3334&scoped=true&"
import script from "./RelatorioDapsTomados.vue?vue&type=script&lang=js&"
export * from "./RelatorioDapsTomados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eab3334",
  null
  
)

export default component.exports